import { render, staticRenderFns } from "./registration-stepper.vue?vue&type=template&id=6b0785ea&scoped=true&"
import script from "./registration-stepper.vue?vue&type=script&lang=ts&"
export * from "./registration-stepper.vue?vue&type=script&lang=ts&"
import style0 from "./registration-stepper.vue?vue&type=style&index=0&id=6b0785ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0785ea",
  null
  
)

export default component.exports